import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import {
	VideoProjectCreationProvider,
	useVideoProjectCreation,
} from '@contexts/VideoProjectCreation.context';
import StageProgress from './components/StageProgress';
import VideoFileSelector from './stages/VideoFileSelector';
import VideoPreviewAndConfiguration from './stages/VideoPreviewAndConfiguration';
import VideoUpload from './stages/VideoUpload';
import Finalize from './stages/Finalize';
import Button from 'react-bootstrap/Button';

const WizardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 1rem 0;
`;

const NavigationButtons = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	padding-top: 1rem;
	border-top: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.2);
`;

const VideoProjectWizardContent = () => {
	const { currentStage, nextStage, previousStage, canProceedFromStage, isUploading } =
		useVideoProjectCreation();

	const canGoNext = canProceedFromStage(currentStage);
	const canGoBack = currentStage > 3 && currentStage < 6 && !isUploading;

	// Hide navigation on upload and finalize stages (upload has its own buttons)
	const showNavigation = currentStage < 5;

	return (
		<WizardContainer>
			<StageProgress current={currentStage} total={6} />

			{currentStage === 3 && <VideoFileSelector />}
			{currentStage === 4 && <VideoPreviewAndConfiguration />}
			{currentStage === 5 && <VideoUpload />}
			{currentStage === 6 && <Finalize />}

			{showNavigation && (
				<NavigationButtons>
					<Button variant="secondary" onClick={previousStage} disabled={!canGoBack}>
						← Previous
					</Button>

					<Button variant="success" onClick={nextStage} disabled={!canGoNext}>
						Next →
					</Button>
				</NavigationButtons>
			)}
		</WizardContainer>
	);
};

const VideoProjectWizard = () => {
	const { watch } = useFormContext();

	const projectInfo = {
		title: watch('projectName'),
		description: watch('projectDescription'),
		tags: watch('projectTags')?.map(tag => tag.value) || [],
	};

	return (
		<VideoProjectCreationProvider projectInfo={projectInfo}>
			<VideoProjectWizardContent />
		</VideoProjectCreationProvider>
	);
};

export default VideoProjectWizard;
